import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          &copy; {new Date().getFullYear()} Quantumke. &nbsp; All rights reserved. &nbsp;
          <span className="crafted">
            Crafted with <span role="img" aria-label="love">❤️</span> by 
            <a href="http://amun-consulting.com/" target="_blank" rel="noopener noreferrer">
              &nbsp;Amun Consulting.
            </a>
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
